module.exports = "/static/assets/8da626006f876af32c3df882283c44ec.png";